import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const ControlDisconnectedIcon = ({ width = 30, height = 30 }: { width?: number; height?: number }) => {
  const { token } = useToken();
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd">
        <g>
          <g transform="translate(-470 -65) translate(464.483 59.483)">
            <circle cx="25.517" cy="25.517" r="10.345" fill={token.colorText} />
            <path
              fill={token.colorBgContainer}
              d="M25.517 13.793c6.213 0 11.296 4.832 11.699 10.942h.025V26.3h-.025c-.402 6.11-5.486 10.942-11.699 10.942-6.212 0-11.296-4.832-11.698-10.942h-.026v-1.563h.026c.402-6.111 5.486-10.943 11.698-10.943zm0 21.885c5.349 0 9.732-4.133 10.132-9.38h-1.59c-.379 2.652-2.658 4.69-5.414 4.69-.266 0-.527-.018-.783-.055v-3.071h-1.563V26.3l1.563-.001v-1.563h-1.563v-1.563h1.563v-3.07c.256-.037.517-.056.783-.056 2.756 0 5.035 2.038 5.415 4.69h1.589c-.4-5.247-4.783-9.38-10.132-9.38-5.349 0-9.732 4.133-10.131 9.38h1.589c.38-2.652 2.659-4.69 5.415-4.69.265 0 .527.019.782.056v10.83c-.255.038-.517.057-.782.057-2.756 0-5.036-2.039-5.415-4.69h-1.59c.4 5.246 4.783 9.38 10.132 9.38zm3.908-13.99v7.66l.219-.052c1.673-.441 2.908-1.966 2.908-3.779s-1.235-3.337-2.908-3.779l-.219-.05zm-7.816-.002l-.218.052c-1.674.442-2.908 1.966-2.908 3.78 0 1.812 1.234 3.337 2.908 3.778l.218.051v-7.661z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ControlDisconnectedIcon;
